import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#02568e',
                accent: '#cf202a'
            }
        },
        options: {
            customProperties: true,
        }
    }
});
